











 












const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StageTimerDisplayStage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isComplete",
      "storageKey": null
    },
    {
      "alias": "scheduledEndTime",
      "args": null,
      "kind": "ScalarField",
      "name": "__scheduledEndTime_localTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeRemaining",
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "localScheduledEndTime",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "NewMeetingStage",
  "abstractKey": "__isNewMeetingStage"
};

(node ).hash = "2e9286e3c1ae0a7c2ee110d06361218f";

export default node;
